import { useSelector } from "react-redux";
import { RouteComponentProps } from "react-router";
import { ClientGrantApi } from "go-component/components/ClientDetails/services/types";
import SettingsClientGrantsPage from "go-component/components/ClientGrants";
import { selectOrganization } from "go-security/services/organizations/selectors";
import { apiOrganization } from "../../../../../../../../services/Api/Organization/apiOrganization";

const OrganizationClientGrantsApi = (props: RouteComponentProps) => {
	const organization = useSelector(selectOrganization);

	return (
		<SettingsClientGrantsPage
			{...props}
			getClientGrants={(params, config) => apiOrganization.getClientGrants(params, config)}
			getClientGrant={(clientGrantId: string, params) => apiOrganization.getClientGrant(clientGrantId, params)}
			createClientGrant={(clientGrantData: ClientGrantApi, params?: Record<string, any>) =>
				apiOrganization.createClientGrant(clientGrantData, params)
			}
			updateClientGrant={(clientGrantId: number, clientGrantData: ClientGrantApi, params?: Record<string, any>) =>
				apiOrganization.updateClientGrant(clientGrantId, clientGrantData, params)
			}
			revokeClientGrant={(clientGrantId: number, params) =>
				apiOrganization.revokeClientGrant(clientGrantId, params)
			}
			getDocsPath={() => apiOrganization.getClientGrantDocsPath()}
			organizationName={organization.name}
			taxIdNo={organization?.more?.print_company_on_pdf ? organization.more?.company_tax_id_no : undefined}
			company={organization?.more?.print_company_on_pdf ? organization.more?.company_name : undefined}
			pdfOrientation={organization?.more?.pdf_orientation}
			pdfFontSize={organization?.more?.default_pdf_font_size?.toString()}
			organizationTimezone={organization?.timezone}
		/>
	);
};

export default OrganizationClientGrantsApi;
